/* const loadBtn = e => {
    e.preventDefault()
    e.target.innerHTML = 
    `<svg class="rotate-btn" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.7184 10.0305C21.073 8.17422 18.6789 7 16 7C11.0289 7 7 11.0289 7 16H9.25C9.25 12.2699 12.2699 9.25 16 9.25C18.0566 9.25 19.8813 10.1816 21.1152 11.6336L18.9988 13.75H25V7.74883L22.7184 10.0305ZM16 22.75C13.9434 22.75 12.1187 21.8184 10.8848 20.3664L13.0012 18.25H7V24.2512L9.28164 21.9695C10.927 23.8258 13.3246 25 16 25C20.9711 25 25 20.9711 25 16H22.75C22.75 19.7301 19.7301 22.75 16 22.75Z" fill="#040404"/>
    </svg>`
} */
const sendGAnalytics = param => {
    console.log("GA Event", param)
    gtag('event', 'click', {
        'cart_buy_more_btn': param
    });    
}
document.addEventListener("DOMContentLoaded", e => {
    let addedFromUpsell = false
    let upsellIndex = 0
    
    /* const swiperUpsells = new Swiper('.cu_swiper', {
        spaceBetween: 20,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        navigation: {
            nextEl: '.cu_v1 .cu_btn_next',
            prevEl: '.cu_v1 .cu_btn_prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 2,
            }
        }
    }); */

    /* document.querySelectorAll(".custom_cart .cu_slide .cu_atc").forEach(atc => {
        atc.addEventListener("click", e => {
            addedFromUpsell = true
            swiperUpsells.removeSlide(+e.target.closest(".cu_slide").getAttribute("data-swiper-slide-index"))
            swiperUpsells.appendSlide(document.querySelectorAll(".hidden_upsells .cu_slide")[upsellIndex])
            upsellIndex++
        })
    }) */
    loadUpsellsV2 = _ => {
        if(document.querySelectorAll(".cu-v2 .cu_slide").length == 0){
            document.querySelector(".cu-v2").classList.add("hide")
        }else{
            document.querySelector(".cu-v2").classList.remove("hide")
        }
        const swiperUpsellsV2 = new Swiper('.cu_swiper_v2', {
                spaceBetween: 5,
                slidesPerView: 2,
                slidesPerGroup: 1,
                loop: true,
                navigation: {
                    nextEl: '.cu-v2 .cu_btn_next',
                    prevEl: '.cu-v2 .cu_btn_prev',
                },
                pagination: {
                    el: '.cu-v2 .swiper-pagination',
                },
                breakpoints: {
                    768: {
                        spaceBetween: 10
                    }
                }
        });
    }
    /* loadUpsellsV2() */
})